import { ShimmeredDetailsListProps } from "@bps/fluent-ui";
import { FieldDeviceRoleType } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";

import { BaseTenantDeplomentRings } from "./BaseTenantDeploymentRings";

interface ServerDeploymentRingsTableProps extends ShimmeredDetailsListProps {
  tenant: Tenant;
}

export const ServerDeploymentRingsTable = ({
  items,
  ...props
}: ServerDeploymentRingsTableProps) => {
  const fieldDeviceRoleType = FieldDeviceRoleType.Server;
  const serverDeploymentRings = items?.filter(
    val => val.fieldDeviceRoleTypeSid === fieldDeviceRoleType
  );
  return (
    <BaseTenantDeplomentRings
      fieldDeviceRoleType={fieldDeviceRoleType}
      heading="Server Deployment Ring"
      items={serverDeploymentRings}
      {...props}
    />
  );
};
